import { LoadingStatuses } from '@/common/constants';
import React, { useState } from 'react';
import styled from 'styled-components';
import AppButton, { AppButtonProps } from './AppButton';

const ButtonContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const MainContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const SubLabel = styled.span`
  color: var(--gray-darker);
  font-size: var(--xxsmall-font-size);
  line-height: 12px;
  font-weight: normal;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  height: 0;
  overflow: hidden;
  font-stretch: 40%;
  letter-spacing: 0.2;

  &.visible {
    opacity: 1;
    height: auto;
  }
`;

const IconWrapper = styled.span`
  &.p-button-icon {
    display: flex;
    align-items: center;
  }
`;

export type HoverButtonProps = AppButtonProps & {
  subLabel?: string;
};

const HoverButton: React.FC<HoverButtonProps> = ({
  subLabel,
  label,
  icon,
  iconPos = 'left',
  state,
  ...appButtonProps
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const customContent = subLabel ? (
    <ButtonContent>
      <MainContent>
        {iconPos === 'left' && icon && (
          <IconWrapper className="p-button-icon">
            {state === LoadingStatuses.LOADING ? (
              <i className="pi pi-spin pi-spinner" />
            ) : typeof icon === 'string' ? (
              <i className={icon} />
            ) : (
              icon
            )}
          </IconWrapper>
        )}
        <span>{label}</span>
        {iconPos === 'right' && icon && (
          <IconWrapper className="p-button-icon">
            {state === LoadingStatuses.LOADING ? (
              <i className="pi pi-spin pi-spinner" />
            ) : typeof icon === 'string' ? (
              <i className={icon} />
            ) : (
              icon
            )}
          </IconWrapper>
        )}
      </MainContent>
      <SubLabel className={isHovered ? 'visible' : ''}>{subLabel}</SubLabel>
    </ButtonContent>
  ) : undefined;

  return (
    <div
      style={{ position: 'relative' }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <AppButton
        {...appButtonProps}
        label={label}
        icon={subLabel ? undefined : icon}
        iconPos={iconPos}
      >
        {customContent}
      </AppButton>
    </div>
  );
};

export default HoverButton;
